// assets/ecomific-shopping-location.js
// Shopping location selector that maps to east/west cart region.
(function () {
  'use strict';

  if (window.__ECOMIFIC_SHOPPING_LOCATION_INIT__) {
    return;
  }
  window.__ECOMIFIC_SHOPPING_LOCATION_INIT__ = true;

  var COOKIE_NAME = 'ecomific_shopping_location';
  var DEFAULT_LOCATION = 'QC';
  var VALID_LOCATIONS = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NS',
    'ON',
    'PE',
    'QC',
    'SK',
    'TERRITORIES',
    'US',
  ];
  var WEST = ['BC', 'AB', 'MB', 'SK'];
  var SOURCE_COOKIE = 'ecomific_shopping_location_source';
  var SOURCE_MANUAL = 'manual';
  var SOURCE_LIQUID = 'liquid';
  var SOURCE_DEFAULT = 'default';
  var SOURCE_GEO = 'geo';
  var SOURCE_HANDOFF = 'handoff';
  var WEST_FALLBACK = 'BC';
  var CA_HOSTS = ['upsidedrinks.ca', 'www.upsidedrinks.ca'];
  var COM_HOSTS = ['upsidedrinks.com', 'www.upsidedrinks.com'];
  var LABELS = {
    QC: 'Québec',
    ON: 'Ontario',
    BC: 'British Columbia',
    AB: 'Alberta',
    MB: 'Manitoba',
    SK: 'Saskatchewan',
    NB: 'New Brunswick',
    NS: 'Nova Scotia',
    PE: 'Prince Edward Island',
    NL: 'Newfoundland & Labrador',
    TERRITORIES: 'Territories (YT/NT/NU)',
    US: 'United States',
  };
  var COOKIE_MAX_AGE_DAYS = 365;
  var DROPDOWN_OPEN_CLASS = 'is-open';
  var REGION_STATE_SELECTOR = '#ecomific-region-state, script[data-ecomific-region-state]';
  var GEO_ATTEMPT_KEY = 'ecomific_geo_attempt_ts';
  var GEO_ATTEMPT_COOLDOWN_MS = 5 * 60 * 1000;
  var PREVIEW_THEME_KEY = 'ecomific_preview_theme_id';
  var REDIRECT_LOCK_KEY = 'ecomific_domain_redirect_lock';
  var REDIRECT_LOCK_MS = 10000;
  var LAST_CA_LOCATION_KEY = 'ecomific_last_ca_location';
  var RETURN_CA_PARAM = 'ecomific_return_ca';
  var SHOPIFY_COUNTRY_SYNC_KEY = 'ecomific_shopify_country_sync';
  var SHOPIFY_COUNTRY_SYNC_MS = 5000;
  var LOG_NS = 'ecomific';
  var MODULE = 'shopping-location';

  if (window.ecomificShoppingLocation && window.ecomificShoppingLocation.initialized) {
    return;
  }

  var currentLocation = null;
  var currentRegion = null;
  var locationSource = SOURCE_DEFAULT;
  var root = null;
  var dropdown = null;
  var trigger = null;
  var labelEl = null;
  var uiController = null;
  var currencyControllers = [];

  function isDebugEnabled() {
    if (typeof window === 'undefined') return false;
    if (window.ecomificDebug === true || window.__ecomificDebug === true) {
      return true;
    }

    try {
      if (window.localStorage && window.localStorage.getItem('ecomific_debug') === '1') {
        return true;
      }
    } catch (e) {}

    try {
      if (window.location && window.location.search) {
        var params = new URLSearchParams(window.location.search);
        if (params.has('ecomificDebug')) {
          return true;
        }
      }
    } catch (e) {}

    return false;
  }

  function fmt(level, msg) {
    return '[' + LOG_NS + '][' + level + '] ' + MODULE + ': ' + msg;
  }

  function logDebug(msg) {
    if (!isDebugEnabled()) return;
    if (typeof console !== 'undefined' && console.debug) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('debug', msg));
      console.debug.apply(console, args);
    }
  }

  function logInfo(msg) {
    if (!isDebugEnabled()) return;
    if (typeof console !== 'undefined' && console.info) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('info', msg));
      console.info.apply(console, args);
    }
  }

  function logWarn(msg) {
    if (typeof console !== 'undefined' && console.warn) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('warn', msg));
      console.warn.apply(console, args);
    }
  }

  function logError(msg) {
    if (typeof console !== 'undefined' && console.error) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('error', msg));
      console.error.apply(console, args);
    }
  }

  function getPinnedPreviewThemeId() {
    try {
      return (window.sessionStorage && window.sessionStorage.getItem(PREVIEW_THEME_KEY)) || '';
    } catch (e) {
      return '';
    }
  }

  function pinPreviewThemeIdFromUrl(url) {
    try {
      var id = url && url.searchParams ? url.searchParams.get('preview_theme_id') : '';
      if (id && window.sessionStorage) {
        window.sessionStorage.setItem(PREVIEW_THEME_KEY, id);
      }
    } catch (e) {}
  }

  function ensurePreviewThemeId(url) {
    try {
      if (!url || !url.searchParams) return;
      var existing = url.searchParams.get('preview_theme_id');
      if (existing) return;
      var pinned = getPinnedPreviewThemeId();
      if (!pinned && typeof window.__ECOMIFIC_PREVIEW_THEME_ID__ === 'string') {
        pinned = window.__ECOMIFIC_PREVIEW_THEME_ID__;
      }
      if (pinned) {
        url.searchParams.set('preview_theme_id', pinned);
      }
    } catch (e) {}
  }

  function readRedirectLock() {
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem(REDIRECT_LOCK_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function isRedirectLocked(fromOrigin, toOrigin, path) {
    var lock = readRedirectLock();
    if (!lock) return false;
    if ((Date.now() - (lock.ts || 0)) > REDIRECT_LOCK_MS) return false;
    if (lock.from !== fromOrigin) return false;
    if (lock.to !== toOrigin) return false;
    if (lock.path && path && lock.path !== path) return false;
    return true;
  }

  function normalizeLocation(value) {
    if (typeof value !== 'string') return null;
    var upper = value.trim().toUpperCase();
    return VALID_LOCATIONS.indexOf(upper) !== -1 ? upper : null;
  }

  function normalizeRegion(value) {
    if (typeof value !== 'string') return null;
    var normalized = value.trim().toLowerCase();
    return normalized === 'east' || normalized === 'west' ? normalized : null;
  }

  function normalizeSource(value) {
    if (value === SOURCE_MANUAL || value === SOURCE_LIQUID || value === SOURCE_DEFAULT || value === SOURCE_GEO || value === SOURCE_HANDOFF) {
      return value;
    }
    return null;
  }

  function sourceToken(value) {
    if (typeof value !== 'string') return '';
    var normalized = value.trim().toLowerCase();
    if (!normalized) return '';
    var idx = normalized.lastIndexOf(':');
    return idx === -1 ? normalized : normalized.slice(idx + 1);
  }

  function isCaHost() {
    if (typeof window === 'undefined' || !window.location || !window.location.hostname) return false;
    var h = window.location.hostname.toLowerCase();
    return h === 'upsidedrinks.ca' || h === 'www.upsidedrinks.ca';
  }

  function isComHost() {
    if (typeof window === 'undefined' || !window.location || !window.location.hostname) return false;
    var h = window.location.hostname.toLowerCase();
    return h === 'upsidedrinks.com' || h === 'www.upsidedrinks.com';
  }

  function getCaOrigin() {
    var protocol = (typeof window !== 'undefined' && window.location && window.location.protocol) ? window.location.protocol : 'https:';
    return protocol + '//upsidedrinks.ca';
  }

  function getComOrigin() {
    var protocol = (typeof window !== 'undefined' && window.location && window.location.protocol) ? window.location.protocol : 'https:';
    return protocol + '//upsidedrinks.com';
  }

  function getLocationStateFromCookies() {
    var location = normalizeLocation(getCookie(COOKIE_NAME));
    var normalizedSource = normalizeSource(getCookie(SOURCE_COOKIE));

    return {
      location: location,
      source: normalizedSource,
    };
  }

  function setLocationCookies(locationCode, source) {
    if (!locationCode) return;

    var normalizedSource = normalizeSource(source) || SOURCE_DEFAULT;

    setCookie(COOKIE_NAME, locationCode);
    setCookie(SOURCE_COOKIE, normalizedSource);
    if (locationCode !== 'US') {
      persistLastCanadianLocation(locationCode);
    }
    locationSource = normalizedSource;
  }

  function persistLastCanadianLocation(locationCode) {
    var normalized = normalizeLocation(locationCode);
    if (!normalized || normalized === 'US') return;

    try {
      if (window.localStorage) {
        window.localStorage.setItem(LAST_CA_LOCATION_KEY, normalized);
      }
    } catch (e) {}
  }

  function getLastCanadianLocation() {
    try {
      var stored = window.localStorage && window.localStorage.getItem(LAST_CA_LOCATION_KEY);
      var normalizedStored = normalizeLocation(stored);
      if (normalizedStored && normalizedStored !== 'US') {
        return normalizedStored;
      }
    } catch (e) {}

    var cookieState = getLocationStateFromCookies();
    if (cookieState.location && cookieState.location !== 'US') {
      return cookieState.location;
    }

    if (currentLocation && currentLocation !== 'US') {
      return currentLocation;
    }

    var browserFallback = deriveBrowserFallbackLocation();
    if (browserFallback && browserFallback !== 'US') {
      return browserFallback;
    }

    return DEFAULT_LOCATION;
  }

  function getReturnCanadianLocationFromUrl() {
    if (typeof window === 'undefined' || !window.location || !window.location.search) return null;
    try {
      var params = new URLSearchParams(window.location.search);
      return normalizeLocation(params.get(RETURN_CA_PARAM));
    } catch (e) {
      return null;
    }
  }

  function getExpectedShopifyCountry(locationCode) {
    return normalizeLocation(locationCode) === 'US' ? 'US' : 'CA';
  }

  function readShopifyCountrySyncLock() {
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem(SHOPIFY_COUNTRY_SYNC_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeShopifyCountrySyncLock(countryCode) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(SHOPIFY_COUNTRY_SYNC_KEY, JSON.stringify({
          country: countryCode,
          host: window.location.hostname,
          ts: Date.now(),
        }));
      }
    } catch (e) {}
  }

  function isShopifyCountrySyncLocked(countryCode) {
    var lock = readShopifyCountrySyncLock();
    if (!lock) return false;
    if (lock.country !== countryCode) return false;
    if (lock.host !== window.location.hostname) return false;
    return (Date.now() - (lock.ts || 0)) < SHOPIFY_COUNTRY_SYNC_MS;
  }

  function findLocalizationFormForCountry() {
    var inputs = document.querySelectorAll('[data-disclosure-form] input[name="country_code"][data-disclosure-input]');
    if (!inputs || !inputs.length) return null;

    for (var i = 0; i < inputs.length; i += 1) {
      var input = inputs[i];
      var form = input.closest('[data-disclosure-form]');
      if (form) {
        return {
          form: form,
          input: input,
        };
      }
    }

    return null;
  }

  function syncShopifyCountryState(locationCode) {
    var expectedCountry = getExpectedShopifyCountry(locationCode);
    var localization = findLocalizationFormForCountry();
    if (!localization || !localization.form || !localization.input) return Promise.resolve(false);
    if (String(localization.input.value || '').toUpperCase() === expectedCountry) {
      return Promise.resolve(false);
    }
    if (isShopifyCountrySyncLocked(expectedCountry)) {
      return Promise.resolve(false);
    }

    var formData = new FormData(localization.form);
    formData.set('country_code', expectedCountry);
    writeShopifyCountrySyncLock(expectedCountry);

    return fetch(localization.form.getAttribute('action') || window.location.pathname + window.location.search, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      redirect: 'follow',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function () {
        localization.input.value = expectedCountry;
        logInfo('shopify country synced', {
          expectedCountry: expectedCountry,
          location: locationCode,
          host: window.location.hostname,
        });
        return true;
      })
      .catch(function (error) {
        logWarn('Could not sync Shopify country state', {
          expectedCountry: expectedCountry,
          location: locationCode,
          message: error && error.message,
        });
        return false;
      });
  }

  function defaultLocationForRegion(region) {
    return region === 'west' ? WEST_FALLBACK : DEFAULT_LOCATION;
  }

  function fetchGeoFromEndpoint(timeoutMs) {
    var url = window.ECOMIFIC_GEO_ENDPOINT_URL;
    if (!url) return Promise.resolve(null);

    try {
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = null;

      if (controller) {
        timer = setTimeout(function () {
          controller.abort();
        }, typeof timeoutMs === 'number' ? timeoutMs : 700);
      }

      return fetch(url, {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          if (timer) {
            clearTimeout(timer);
          }
          if (!res.ok) return null;
          return res.json().catch(function () {
            return null;
          });
        })
        .catch(function () {
          return null;
        });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  function normalizeEndpointGeo(payload) {
    if (!payload || typeof payload !== 'object') return null;

    var regionCode = payload.region ? String(payload.region).toUpperCase() : null;
    if (!regionCode) return null;

    return {
      location: regionCode,
      source: SOURCE_GEO
    };
  }

  function parseRegionLiquidState() {
    var el = document.querySelector(REGION_STATE_SELECTOR);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}') || null;
    } catch (error) {
      logWarn('Failed to parse region state JSON', error);
      return null;
    }
  }

  function deriveDefaultLocationFromLiquid() {
    var state = parseRegionLiquidState();
    if (!state || !state.default_province_code) {
      return { location: null, loggedIn: false };
    }

    var code = String(state.default_province_code).trim().toUpperCase();
    return {
      location: normalizeLocation(code),
      loggedIn: !!state.customer_logged_in,
    };
  }

  function getBrowserLocaleCountry() {
    try {
      var locale =
        (typeof navigator !== 'undefined' && (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
      var match = String(locale).match(/-([A-Za-z]{2})$/);
      return match ? match[1].toUpperCase() : null;
    } catch (e) {
      return null;
    }
  }

  function getBrowserTimeZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (e) {
      return '';
    }
  }

  function deriveBrowserFallbackLocation() {
    var timeZone = String(getBrowserTimeZone() || '');
    var localeCountry = getBrowserLocaleCountry();

    if (timeZone) {
      if (timeZone === 'America/Vancouver' || timeZone === 'America/Dawson' || timeZone === 'America/Fort_Nelson') {
        return 'BC';
      }
      if (timeZone === 'America/Edmonton') {
        return 'AB';
      }
      if (timeZone === 'America/Regina' || timeZone === 'America/Swift_Current') {
        return 'SK';
      }
      if (timeZone === 'America/Winnipeg' || timeZone === 'America/Rainy_River') {
        return 'MB';
      }
      if (
        timeZone === 'America/Whitehorse' ||
        timeZone === 'America/Inuvik' ||
        timeZone === 'America/Yellowknife' ||
        timeZone === 'America/Cambridge_Bay'
      ) {
        return 'TERRITORIES';
      }
      if (timeZone === 'America/St_Johns' || timeZone === 'America/Goose_Bay' || timeZone === 'America/Blanc-Sablon') {
        return 'NL';
      }
      if (timeZone === 'America/Halifax' || timeZone === 'America/Glace_Bay') {
        return 'NS';
      }
      if (timeZone === 'America/Moncton') {
        return 'NB';
      }
      if (timeZone === 'America/Toronto' || timeZone === 'America/Nipigon' || timeZone === 'America/Thunder_Bay') {
        return localeCountry === 'CA' && String((navigator && navigator.language) || '').toLowerCase().indexOf('fr') === 0
          ? 'QC'
          : 'ON';
      }
    }

    if (localeCountry === 'US') return 'US';

    if (localeCountry === 'CA') {
      try {
        var locale = String((navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || '').toLowerCase();
        if (locale.indexOf('fr') === 0) return 'QC';
      } catch (e) {}
      return 'ON';
    }

    return null;
  }

  function getGeoSeedLocation() {
    var geo = window.ecomificGeo;
    if (!geo || typeof geo !== 'object') return null;

    // Prefer explicit location code when provided.
    if (geo.location) {
      return normalizeLocation(String(geo.location));
    }

    // Support region-only geo hooks by mapping to a safe default location.
    if (geo.region) {
      var r = normalizeRegion(String(geo.region));
      if (r) return defaultLocationForRegion(r);
    }

    return null;
  }


  function locationToRegion(locationCode) {
    var code = normalizeLocation(locationCode);
    if (!code) return null;
    return WEST.indexOf(code) !== -1 ? 'west' : 'east';
  }

  function geoDebugEnabled() {
    return isDebugEnabled();
  }

  function getCookie(name) {
    if (typeof document === 'undefined') return null;
    var pattern = '; ' + document.cookie;
    var parts = pattern.split('; ' + name + '=');
    if (parts.length < 2) return null;
    return parts.pop().split(';').shift();
  }

  function setCookie(name, value) {
    if (typeof document === 'undefined') return;
    var expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_MAX_AGE_DAYS);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; Expires=' +
      expires.toUTCString() +
      '; Path=/; SameSite=Lax';
  }

  function getGeoCooldownTs() {
    if (typeof window === 'undefined') return null;
    var raw = null;

    try {
      if (window.sessionStorage) {
        raw = window.sessionStorage.getItem(GEO_ATTEMPT_KEY);
      }
    } catch (error) {
      raw = null;
    }

    if (raw === null) {
      try {
        if (window.localStorage) {
          raw = window.localStorage.getItem(GEO_ATTEMPT_KEY);
        }
      } catch (error) {
        raw = null;
      }
    }

    if (raw === null) return null;
    var ts = Number(raw);
    return isFinite(ts) ? ts : null;
  }

  function setGeoCooldownTs(ts) {
    if (typeof window === 'undefined') return;
    if (typeof ts !== 'number' || !isFinite(ts)) return;
    var value = String(ts);
    var stored = false;

    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(GEO_ATTEMPT_KEY, value);
        stored = true;
      }
    } catch (error) {
      // noop
    }

    if (stored) return;

    try {
      if (window.localStorage) {
        window.localStorage.setItem(GEO_ATTEMPT_KEY, value);
      }
    } catch (error) {
      // noop
    }
  }

  function clearGeoCooldownTs() {
    if (typeof window === 'undefined') return;

    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem(GEO_ATTEMPT_KEY);
      }
    } catch (error) {
      // noop
    }

    try {
      if (window.localStorage) {
        window.localStorage.removeItem(GEO_ATTEMPT_KEY);
      }
    } catch (error) {
      // noop
    }
  }

  function ensureShoppingLocation() {
    var cookieState = getLocationStateFromCookies();
    var cookieLocation = cookieState.location;
    var cookieSource = normalizeSource(cookieState.source) || SOURCE_DEFAULT;
    var liquidInfo = deriveDefaultLocationFromLiquid();
    var liquidLocation = liquidInfo.location;
    var liquidLoggedIn = liquidInfo.loggedIn;

    if (cookieLocation) {
      locationSource = cookieSource;
      setCookie(SOURCE_COOKIE, locationSource);
      return cookieLocation;
    }

    if (liquidLoggedIn && liquidLocation) {
      setLocationCookies(liquidLocation, SOURCE_LIQUID);
      return liquidLocation;
    }

    // Guests only: seed once from optional geolocation hook.
    // Does nothing if a shopping-location cookie already exists.
    var geoLocation = getGeoSeedLocation();
    if (!liquidLoggedIn && geoLocation) {
      setLocationCookies(geoLocation, SOURCE_GEO);
      return geoLocation;
    }

    var browserFallbackLocation = deriveBrowserFallbackLocation();
    if (!liquidLoggedIn && browserFallbackLocation) {
      setLocationCookies(browserFallbackLocation, SOURCE_DEFAULT);
      return browserFallbackLocation;
    }

    setLocationCookies(DEFAULT_LOCATION, SOURCE_DEFAULT);
    return DEFAULT_LOCATION;
  }

  function maybeSeedFromGeoEndpoint(timeoutMs) {
    var debug = geoDebugEnabled();
    var start = Date.now();
    var cookieState = getLocationStateFromCookies();
    var cookieLocation = cookieState.location;
    var cookieSource = normalizeSource(cookieState.source);
    function failWithCooldown(reason, extra) {
      if (debug) {
        var info = { reason: reason };
        if (extra && typeof extra === 'object') {
          for (var key in extra) {
            if (Object.prototype.hasOwnProperty.call(extra, key)) {
              info[key] = extra[key];
            }
          }
        }
        logInfo('geo skip', info);
      }
      setGeoCooldownTs(Date.now());
      return false;
    }

    if (debug) {
      logInfo('geo start', {
        endpoint: window.ECOMIFIC_GEO_ENDPOINT_URL || null,
        timeoutMs: timeoutMs,
        existingLocationCookie: cookieLocation || null,
        existingSourceCookie: cookieSource || null,
      });
    }

    if (
      cookieLocation &&
      cookieSource &&
      cookieSource !== SOURCE_DEFAULT
    ) {
      if (debug) {
        logInfo('geo skip', {
          reason: 'cookie-authoritative',
          source: cookieSource,
        });
      }
      return Promise.resolve(false);
    }

    var liquidState = parseRegionLiquidState();
    if (liquidState && liquidState.customer_logged_in) {
      if (debug) {
        logInfo('geo skip', {
          reason: 'customer-logged-in',
        });
      }
      return Promise.resolve(false);
    }

    var endpoint =
      typeof window.ECOMIFIC_GEO_ENDPOINT_URL === 'string'
        ? window.ECOMIFIC_GEO_ENDPOINT_URL.trim()
        : '';

    if (!endpoint) {
      if (debug) {
        logInfo('geo skip', {
          reason: 'no-endpoint',
        });
      }
      return Promise.resolve(false);
    }

    var lastAttemptTs = getGeoCooldownTs();
    if (lastAttemptTs !== null) {
      var elapsedSinceLastAttempt = Date.now() - lastAttemptTs;
      if (elapsedSinceLastAttempt < GEO_ATTEMPT_COOLDOWN_MS) {
        if (debug) {
          var remainingMs = GEO_ATTEMPT_COOLDOWN_MS - elapsedSinceLastAttempt;
          logInfo('geo skip', {
            reason: 'cooldown',
            remainingMs: remainingMs,
            remainingSeconds: Math.ceil(remainingMs / 1000),
          });
        }
        return Promise.resolve(false);
      }
    }

    setGeoCooldownTs(Date.now());
    return fetchGeoFromEndpoint(timeoutMs).then(
      function (payload) {
        if (debug) {
          logInfo('geo response', {
            elapsedMs: Date.now() - start,
            payload: payload || null,
          });
        }

        if (payload && payload.debug && payload.debug.error) {
          return failWithCooldown('debug-error', {
            error: payload.debug.error,
            upstreamStatus: payload.debug.upstreamStatus || null,
          });
        }

        if (!payload || !payload.region) {
          return failWithCooldown('missing-region');
        }

        var normalized = normalizeEndpointGeo(payload);
        if (!normalized) {
          return failWithCooldown('invalid-payload');
        }

        window.ecomificGeo = normalized;
        var seeded = getGeoSeedLocation();
        if (seeded) {
          if (debug) {
            logInfo('geo cookies-before', {
              location: cookieLocation || null,
              source: cookieSource || null,
            });
          }
          setLocationCookies(seeded, SOURCE_GEO);
          try {
            localStorage.setItem('ecomific_geo_seeded', '1');
          } catch (e) {}
          currentRegion = locationToRegion(seeded) || 'east';
          currentLocation = seeded;
          clearGeoCooldownTs();
          if (debug) {
            logInfo('geo seeded', {
              location: getCookie(COOKIE_NAME),
              source: getCookie(SOURCE_COOKIE),
              elapsedMs: Date.now() - start,
            });
          }
          return true;
        }

        return failWithCooldown('getGeoSeedLocation-null');
      },
      function (error) {
        return failWithCooldown('fetch-error', {
          message: error && error.message,
        });
      }
    );
  }

  function dispatchRegionSetRequest(region, source) {
    if (!region) return;
    var locationCode = currentLocation || defaultLocationForRegion(region);
    var country = locationCode === 'US' ? 'us' : 'ca';
    var province = locationCode && locationCode !== 'US' ? locationCode : '';
    var requestedSource = sourceToken(source) || SOURCE_MANUAL;
    logInfo('dispatch set-request', {
      region: region,
      source: requestedSource,
      location: locationCode,
      country: country,
      province: province || '',
    });
    try {
      window.dispatchEvent(
        new CustomEvent('ecomific:region:set-request', {
          detail: {
            region: region,
            country: country,
            province: province || '',
            source: requestedSource,
          },
        })
      );
    } catch (error) {
      logWarn('ecomific:region:set-request dispatch threw', error);
    }
  }

  function updateLabel(labelEl, locationCode) {
    if (!labelEl) return;
    var label = LABELS[locationCode] || LABELS[DEFAULT_LOCATION] || locationCode || '';
    labelEl.textContent = label;
  }

  function getCurrencyCountryForLocation(locationCode) {
    return normalizeLocation(locationCode) === 'US' ? 'US' : 'CA';
  }

  function updateCurrencyUI(rootEl, locationCode) {
    if (!rootEl) return;

    var countryCode = getCurrencyCountryForLocation(locationCode);
    var labelNode = rootEl.querySelector('[data-ecomific-currency-label]');
    var flagNode = rootEl.querySelector('[data-ecomific-currency-flag]');
    var activeOption = rootEl.querySelector('[data-ecomific-currency-option][data-country-code="' + countryCode + '"]');

    if (labelNode && activeOption) {
      var optionLabel = activeOption.querySelector('[data-ecomific-currency-option-label]');
      labelNode.textContent = optionLabel ? optionLabel.textContent.trim() : activeOption.textContent.trim();
    }

    if (flagNode) {
      flagNode.classList.remove('currency-flag--ca');
      flagNode.classList.remove('currency-flag--us');
      flagNode.classList.add('currency-flag--' + countryCode.toLowerCase());
    }

    var items = rootEl.querySelectorAll('[data-ecomific-currency-item]');
    for (var i = 0; i < items.length; i += 1) {
      var option = items[i].querySelector('[data-ecomific-currency-option]');
      var isCurrent = !!option && option.getAttribute('data-country-code') === countryCode;
      items[i].classList.toggle('disclosure-list__item--current', isCurrent);
      if (option) {
        if (isCurrent) {
          option.setAttribute('aria-current', 'true');
        } else {
          option.removeAttribute('aria-current');
        }
      }
    }
  }

  function closeDropdown(root, dropdown, trigger) {
    if (!dropdown) return;
    dropdown.hidden = true;
    if (root) root.classList.remove(DROPDOWN_OPEN_CLASS);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openDropdown(root, dropdown, trigger) {
    if (!dropdown) return;
    dropdown.hidden = false;
    if (root) root.classList.add(DROPDOWN_OPEN_CLASS);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function toggleDropdown(root, dropdown, trigger) {
    if (!dropdown) return;
    var isHidden = dropdown.hidden !== false;
    if (isHidden) {
      openDropdown(root, dropdown, trigger);
    } else {
      closeDropdown(root, dropdown, trigger);
    }
  }

  var OPTION_SELECTED_CLASS = 'ecomific-shopping-location__option--selected';

  function setRootAttrs(root, locationCode, region, source) {
    if (!root) return;
    root.setAttribute('data-location-code', locationCode || '');
    root.setAttribute('data-region', region || '');
    root.setAttribute('data-location-source', source || '');

    var drop = root.querySelector('[data-ecomific-shopping-location-dropdown]');
    if (drop && locationCode) {
      var opts = drop.querySelectorAll('[data-location-code]');
      for (var i = 0; i < opts.length; i++) {
        var isSelected = opts[i].getAttribute('data-location-code') === locationCode;
        opts[i].classList.toggle(OPTION_SELECTED_CLASS, isSelected);
        opts[i].setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected) {
          opts[i].setAttribute('data-active', 'true');
        } else {
          opts[i].removeAttribute('data-active');
        }
      }
    }
  }

  function setReady() {
    if (!root) return;
    root.dataset.ready = 'true';
    root.setAttribute('aria-busy', 'false');
  }

  function bindUI(root) {
    if (!root) return null;

    trigger = root.querySelector('[data-ecomific-shopping-location-trigger]');
    dropdown = root.querySelector('[data-ecomific-shopping-location-dropdown]');
    labelEl = root.querySelector('[data-ecomific-shopping-location-label]');

    if (!trigger || !dropdown) return null;

    var isOpen = false;

    function handleDocumentClick(event) {
      if (!isOpen) return;
      if (!root.contains(event.target)) {
        closeDropdown();
      }
    }

    function handleKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        closeDropdown();
      }
    }

    function openDropdown() {
      if (!dropdown) return;
      dropdown.hidden = false;
      root.classList.add(DROPDOWN_OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', handleDocumentClick);
      document.addEventListener('keydown', handleKeydown);
      isOpen = true;
    }

    function closeDropdown() {
      if (!dropdown) return;
      dropdown.hidden = true;
      root.classList.remove(DROPDOWN_OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keydown', handleKeydown);
      isOpen = false;
    }

    function toggleDropdown() {
      if (dropdown.hidden !== false) {
        openDropdown();
      } else {
        closeDropdown();
      }
    }

    updateLabel(labelEl, currentLocation);
    setRootAttrs(root, currentLocation, currentRegion, locationSource);
    trigger.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') || 'false');

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      toggleDropdown();
    });

    dropdown.addEventListener('click', function (event) {
      var option = event.target ? event.target.closest('[data-location-code]') : null;
      if (!option) return;

      event.preventDefault();

      closeDropdown();

      var code = option.getAttribute('data-location-code');
      if (!code) return;

      var normalizedCode = normalizeLocation(code);
      if (!normalizedCode) return;
      selectLocation(normalizedCode);
    });

    return {
      close: closeDropdown,
      updateLabel: function (locationCode) {
        updateLabel(labelEl, locationCode);
      },
    };
  }

  function bindCurrencyUI() {
    var rootEls = document.querySelectorAll('[data-ecomific-currency-switcher]');
    if (!rootEls || !rootEls.length) return [];

    var controllers = [];

    function closeAllCurrencyDropdowns(exceptRoot) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ecomific-currency-switcher]'), function (switcher) {
        if (exceptRoot && switcher === exceptRoot) return;
        var list = switcher.querySelector('[data-ecomific-currency-list]');
        var toggle = switcher.querySelector('[data-ecomific-currency-trigger]');
        if (list) {
          list.hidden = true;
          list.classList.remove('disclosure-list--visible');
        }
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        switcher.classList.remove(DROPDOWN_OPEN_CLASS);
      });
    }

    if (!window.__ECOMIFIC_CURRENCY_DELEGATED__) {
      document.addEventListener('click', function (event) {
        var option = event.target && event.target.closest
          ? event.target.closest('[data-ecomific-currency-option]')
          : null;
        if (option) {
          event.preventDefault();
          var optionRoot = option.closest('[data-ecomific-currency-switcher]');
          closeAllCurrencyDropdowns();

          var countryCode = String(option.getAttribute('data-country-code') || '').trim().toUpperCase();
          if (countryCode === 'US') {
            selectLocation('US');
            return;
          }

          if (countryCode === 'CA') {
            selectLocation(getLastCanadianLocation());
          }
          return;
        }

        var trigger = event.target && event.target.closest
          ? event.target.closest('[data-ecomific-currency-trigger]')
          : null;
        if (trigger) {
          event.preventDefault();
          var root = trigger.closest('[data-ecomific-currency-switcher]');
          var list = root && root.querySelector('[data-ecomific-currency-list]');
          if (!root || !list) return;

          var willOpen = list.hidden !== false;
          closeAllCurrencyDropdowns(willOpen ? root : null);
          list.hidden = !willOpen;
          list.classList.toggle('disclosure-list--visible', willOpen);
          trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          root.classList.toggle(DROPDOWN_OPEN_CLASS, willOpen);
          return;
        }

        closeAllCurrencyDropdowns();
      }, true);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closeAllCurrencyDropdowns();
        }
      });

      window.__ECOMIFIC_CURRENCY_DELEGATED__ = true;
    }

    Array.prototype.forEach.call(rootEls, function (rootEl) {
      var triggerEl = rootEl.querySelector('[data-ecomific-currency-trigger]');
      var listEl = rootEl.querySelector('[data-ecomific-currency-list]');
      if (!triggerEl || !listEl) return;

      function closeCurrencyDropdown() {
        listEl.hidden = true;
        listEl.classList.remove('disclosure-list--visible');
        triggerEl.setAttribute('aria-expanded', 'false');
        rootEl.classList.remove(DROPDOWN_OPEN_CLASS);
      }

      updateCurrencyUI(rootEl, currentLocation);
      triggerEl.setAttribute('aria-expanded', 'false');

      controllers.push({
        close: closeCurrencyDropdown,
        update: function (locationCode) {
          updateCurrencyUI(rootEl, locationCode);
        },
      });
    });

    return controllers;
  }

  function redirectToLocation(targetOrigin, normalizedCode) {
    var currentUrl = new URL(window.location.href);
    pinPreviewThemeIdFromUrl(currentUrl);
    var pathname = currentUrl.pathname || '/';
    var params = new URLSearchParams(currentUrl.search || '');
    params.set('ecomific_location', normalizedCode);
    if (normalizedCode === 'US' && currentLocation && currentLocation !== 'US') {
      params.set(RETURN_CA_PARAM, currentLocation);
    } else {
      params.delete(RETURN_CA_PARAM);
    }
    var targetUrl = new URL(pathname + (params.toString() ? '?' + params.toString() : ''), targetOrigin);
    ensurePreviewThemeId(targetUrl);
    var fromOrigin = window.location.origin;
    var toOrigin = targetUrl.origin;
    var path = window.location.pathname || '/';
    if (isRedirectLocked(fromOrigin, toOrigin, path)) {
      logInfo('redirect blocked by lock', {
        from: fromOrigin,
        to: toOrigin,
        path: path,
      });
      return;
    }
    window.location.assign(targetUrl.toString());
  }

  function selectLocation(normalizedCode) {
    if (!normalizedCode) return;

    if (normalizedCode === 'US' && isCaHost()) {
      redirectToLocation(getComOrigin(), 'US');
      return;
    }

    if (normalizedCode !== 'US' && isComHost()) {
      redirectToLocation(getCaOrigin(), normalizedCode);
      return;
    }

    var previousRegion = currentRegion;
    var nextRegion = locationToRegion(normalizedCode) || 'east';
    var regionChanged = nextRegion !== previousRegion || normalizedCode !== currentLocation;

    logDebug('select', {
      code: normalizedCode,
      nextRegion: nextRegion,
      previousRegion: previousRegion,
      regionChanged: regionChanged,
    });

    currentLocation = normalizedCode;
    currentRegion = nextRegion;
    locationSource = SOURCE_MANUAL;

    setLocationCookies(currentLocation, SOURCE_MANUAL);
    setRootAttrs(root, currentLocation, nextRegion, locationSource);
    updateLabel(labelEl, currentLocation);

    if (regionChanged) {
      dispatchRegionSetRequest(nextRegion, 'shopping-location:manual');
    }
  }

  function reflectUI() {
    setRootAttrs(root, currentLocation, currentRegion, locationSource);
    updateLabel(labelEl, currentLocation);
    currencyControllers.forEach(function (controller) {
      if (controller && controller.update) {
        controller.update(currentLocation);
      }
    });
    setReady();
    syncShopifyCountryState(currentLocation);
  }

  function reconcileState(nextRegion, source) {
    var cookieState = getLocationStateFromCookies();
    var cookieLocation = cookieState.location;
    var cookieSource = normalizeSource(cookieState.source) || SOURCE_DEFAULT;
    var normalizedRegion = normalizeRegion(nextRegion) || currentRegion || 'east';
    var incomingSource = normalizeSource(source);

    // If a shopping-location cookie exists, it is authoritative.
    if (cookieLocation) {
      currentLocation = cookieLocation;
      currentRegion = locationToRegion(currentLocation) || normalizedRegion || 'east';

      if (cookieSource === SOURCE_MANUAL || locationSource === SOURCE_MANUAL) {
        locationSource = SOURCE_MANUAL;
      } else if (cookieSource) {
        locationSource = cookieSource;
      } else {
        locationSource = locationSource || SOURCE_DEFAULT;
      }

      // Preserve the existing source (e.g., manual) and do not overwrite with liquid/init.
      setCookie(SOURCE_COOKIE, locationSource);

      reflectUI();
      return;
    }

    // No cookie yet: seed based on incoming region and source.
    var nextLocation = defaultLocationForRegion(normalizedRegion);
    var nextSource = incomingSource || cookieSource || locationSource || SOURCE_DEFAULT;

    setLocationCookies(nextLocation, nextSource);
    currentRegion = normalizedRegion;
    currentLocation = nextLocation;

    reflectUI();
  }

  function handleRegionChanged(event) {
    var detail = (event && event.detail) || {};
    reconcileState(detail.region, detail.source);

    if (uiController && typeof uiController.close === 'function') {
      uiController.close();
    }
  }

  function handleRegionReady(event) {
    var detail = (event && event.detail) || {};
    reconcileState(detail.region, detail.source);
  }

  function resolveInitialLocation(timeoutMs) {
    var cookieState = getLocationStateFromCookies();
    var cookieLocation = cookieState.location;
    var cookieSource = normalizeSource(cookieState.source);
    var endpointAvailable =
      typeof window.ECOMIFIC_GEO_ENDPOINT_URL === 'string' &&
      window.ECOMIFIC_GEO_ENDPOINT_URL.trim() !== '';
    var geoAllowed = !cookieLocation;

    logInfo('boot decision', {
      currentLocation: cookieLocation || null,
      currentSource: cookieSource || null,
      geoAllowed: geoAllowed,
      endpoint: endpointAvailable,
    });

    // Authoritative persisted/manual selection — never allow geo override
    if (cookieLocation && cookieSource && cookieSource !== SOURCE_DEFAULT) {
      locationSource = cookieSource;
      setCookie(SOURCE_COOKIE, locationSource);
      return Promise.resolve(cookieLocation);
    }

    // If cookieLocation exists but source missing/unknown, treat as persisted
    if (cookieLocation && !cookieSource) {
      locationSource = SOURCE_DEFAULT;
      setCookie(SOURCE_COOKIE, locationSource);
      return Promise.resolve(cookieLocation);
    }

    var startWithCookie = !!cookieLocation;
    var geoSeedPromise = Promise.resolve(false);
    if (geoAllowed && endpointAvailable) {
      geoSeedPromise = maybeSeedFromGeoEndpoint(timeoutMs);
    }

    return geoSeedPromise
      .catch(function () {
        return false;
      })
      .then(function (seeded) {
        if (seeded) {
          var nextState = getLocationStateFromCookies();
          var nextLocation = nextState.location || currentLocation || cookieLocation;
          locationSource = normalizeSource(nextState.source) || SOURCE_GEO;
          if (nextLocation) {
            return nextLocation;
          }
        }

        if (startWithCookie && cookieLocation) {
          locationSource = cookieSource || SOURCE_DEFAULT;
          setCookie(SOURCE_COOKIE, locationSource);
          return cookieLocation;
        }

        return ensureShoppingLocation();
      })
      .catch(function () {
        if (startWithCookie && cookieLocation) {
          locationSource = cookieSource || SOURCE_DEFAULT;
          setCookie(SOURCE_COOKIE, locationSource);
          return cookieLocation;
        }
        return ensureShoppingLocation();
      });
  }

  function runInit(initialLocation) {
    var normalizedLocation = normalizeLocation(initialLocation);
    if (!normalizedLocation) {
      normalizedLocation = ensureShoppingLocation();
    }

    currentLocation = normalizedLocation;
    currentRegion = locationToRegion(currentLocation) || 'east';

    if (root) {
      uiController = bindUI(root);
    }

    window.addEventListener('ecomific:region:changed', handleRegionChanged);
    window.addEventListener('ecomific:region:ready', handleRegionReady);

    /*
      // Future hook (INTENTIONALLY DISABLED): show a toast when cart region sync fails.
      // Do not enable until we agree on UX pattern + copy.

      function showToast(message) {
        logInfo('toast', message);
        // TODO: Replace with real UI toast implementation.
      }

      window.addEventListener('ecomific:region:sync-failed', function (event) {
        var detail = (event && event.detail) ? event.detail : {};
        logInfo('region sync failed', detail);

        var regionLabel = detail.region ? detail.region.toUpperCase() : 'your selection';
        showToast('We couldn’t update availability for ' + regionLabel + '. Please try again.');
      });
    */

    reflectUI();

    dispatchRegionSetRequest(currentRegion, locationSource);

    if (root) {
      setTimeout(function () {
        if (root && root.dataset.ready === 'false') setReady();
      }, 1500);
    }

    window.ecomificShoppingLocation = {
      initialized: true,
      getLocation: function () {
        return currentLocation;
      },
      getRegion: function () {
        return currentRegion;
      },
      getSource: function () {
        return locationSource;
      },
    };

    if (typeof window !== 'undefined' && window.dispatchEvent && typeof window.CustomEvent !== 'undefined') {
      window.dispatchEvent(new CustomEvent('ecomific:shopping-location:ready', {
        detail: { location: currentLocation, region: currentRegion, source: locationSource },
      }));
    }

    logInfo(
      'Initialized with',
      currentLocation,
      '→',
      currentRegion,
      '(' + locationSource + ')'
    );
  }

  function getHandoffLocationFromUrl() {
    if (typeof window === 'undefined' || !window.location || !window.location.search) return null;
    try {
      var params = new URLSearchParams(window.location.search);
      var value = params.get('ecomific_location');
      return normalizeLocation(value);
    } catch (e) {
      return null;
    }
  }

  function applyHandoffAndStripParam(locationCode) {
    var region = locationToRegion(locationCode) || 'east';
    setLocationCookies(locationCode, SOURCE_HANDOFF);
    currentLocation = locationCode;
    currentRegion = region;
    locationSource = SOURCE_HANDOFF;
    dispatchRegionSetRequest(region, 'shopping-location:handoff');

    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('ecomific_location');
      params.delete(RETURN_CA_PARAM);
      var newSearch = params.toString();
      var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + (window.location.hash || '');
      if (window.history && typeof window.history.replaceState === 'function') {
        window.history.replaceState(null, '', newUrl);
      }
    } catch (e) {
      logWarn('Could not strip ecomific_location param', e);
    }
  }

  function init() {
    if (window.ecomificShoppingLocation && window.ecomificShoppingLocation.initialized) {
      return;
    }
    root =
      document.querySelector('[data-ecomific-shopping-location-root]') ||
      document.querySelector('[data-ecomific-shopping-location]');
    currencyControllers = bindCurrencyUI();

    var returnLocation = getReturnCanadianLocationFromUrl();
    if (returnLocation && returnLocation !== 'US') {
      persistLastCanadianLocation(returnLocation);
    }

    var handoff = getHandoffLocationFromUrl();
    if (handoff) {
      applyHandoffAndStripParam(handoff);
      runInit(handoff);
      return;
    }

    var cookieState = getLocationStateFromCookies();

    resolveInitialLocation(2000)
      .then(function (location) {
        runInit(location);
      })
      .catch(function () {
        runInit(ensureShoppingLocation());
      });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
